import React, { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';

interface AuthenticationResetPasswordProps {
  switchMode: (mode: 'login' | 'signup' | 'reset') => void;
}

const AuthenticationResetPassword: React.FC<AuthenticationResetPasswordProps> = ({
  switchMode,
}) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const { sendPasswordResetEmail } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      setError('');
      setMessage('');
      await sendPasswordResetEmail(email);
      setMessage('Check your inbox for further instructions');
    } catch {
      setError('Failed to reset password');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="mt-8 space-y-6">
      {error && <div className="text-red-500">{error}</div>}
      {message && <div className="text-green-500">{message}</div>}
      <div>
        <label htmlFor="email" className="sr-only">Email address</label>
        <input
          id="email"
          name="email"
          type="email"
          autoComplete="email"
          required
          className="input input-bordered block w-full mt-1"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div>
        <button
          type="submit"
          className="btn btn-primary"
        >
          Reset Password
        </button>
      </div>
      <div className="text-sm">
        <button
          type="button"
          onClick={() => switchMode('login')}
          className="font-medium text-white underline"
        >
          Back to Login
        </button>
      </div>
    </form>
  );
};

export default AuthenticationResetPassword;
